import React, { useState, useEffect } from "react";
import axios from "axios";

const API_URL = 'https://backend.aktcorp.com/cookies/addcookies'; // POST only
// const API_KEY = "154122054"; // Optional API key header

const getUserMetadata = async () => {
  try {
    const ipResponse = await axios.get("https://api64.ipify.org?format=json");
    const ip = ipResponse.data.ip;

    const locationResponse = await axios.get(`https://ipapi.co/${ip}/json/`);
    const location = locationResponse.data;

    return {
      ipAddress: ip || "Unknown",
      userAgent: navigator.userAgent,
      browser: navigator.userAgent.includes("Chrome")
        ? "Chrome"
        : navigator.userAgent.includes("Firefox")
        ? "Firefox"
        : "Other",
      os: navigator.platform,
      device: /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
      screenSize: `${window.screen.width}x${window.screen.height}`,
      referrer: document.referrer || "Direct Visit",
      visitTime: new Date().toISOString(),
      city: location.city || "Unknown",
      region: location.region || "Unknown",
      country: location.country_name || "Unknown",
    };
  } catch (error) {
    console.error("Error fetching user metadata or location:", error);
    return {};
  }
};

const CookiesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000); // Show after 5 seconds
    return () => clearTimeout(timer);
  }, []);

  const handleConsent = async (consent) => {
    setIsVisible(false);

    try {
      const metadata = await getUserMetadata();

      await axios.post(
        API_URL,
        {
          userId: "user123",
          consent,
          metadata,
        },
      );

    } catch (error) {
      console.error("❌ Error saving consent:", error);
    }
  };

  return isVisible ? (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop-blur-sm z-[1000] p-4">
      <div className="bg-white p-5 rounded-2xl shadow-2xl w-full max-w-sm text-center transform scale-100 transition-all duration-300">
        <h2 className="text-lg md:text-xl font-semibold text-gray-900">🍪 Cookie Consent</h2>
        <p className="text-gray-700 mt-3 text-sm md:text-base leading-relaxed">
          We use cookies to personalize content and analyze traffic. Click "Accept" to allow cookies or "Cancel" to reject.
        </p>
        <div className="mt-5 flex flex-col md:flex-row justify-center gap-3 w-full">
          <button
            className="bg-blue-600 text-white font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-200 w-full md:w-1/2"
            onClick={() => handleConsent("Accepted")}
          >
            Accept
          </button>
          <button
            className="bg-gray-300 text-gray-800 font-medium px-4 py-2 rounded-lg hover:bg-gray-400 transition-all duration-200 w-full md:w-1/2"
            onClick={() => handleConsent("Denied")}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default CookiesPopup;
